import { FormControl, FormLabel, Switch } from "@chakra-ui/react";
import { Panel } from "@xyflow/react";
import { GrayScaleContext } from "features/entities/EntityCreatePage/EntityGraph/GrayScaleContext";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

const GrayScaleToggle: React.FC = () => {
  const { setIsGrayScale, isGrayScale } = useContext(GrayScaleContext);
  const { t } = useTranslation(["entity"]);
  return (
    <Panel position="top-left">
      <FormControl display="flex" alignItems="center">
        <FormLabel htmlFor="grayscale-toggle" mb="0">
          {t("entity:create.actions.toggle_bw")}
        </FormLabel>
        <Switch
          checked={isGrayScale}
          onChange={(e) => setIsGrayScale(e.target.checked)}
          id="grayscale-toggle"
        />
      </FormControl>
    </Panel>
  );
};

export default GrayScaleToggle;
